import { create } from "zustand";

interface ConversationTarget {
  entityType: string;
  entityId: string;
  entityTitle: string;
  projectId: string;
}

interface ConversationState {
  /** Whether the conversation panel is open */
  isOpen: boolean;
  /** The active QA session ID */
  sessionId: string | null;
  /** The entity being discussed */
  target: ConversationTarget | null;
  /** Whether the AI is processing a response */
  isProcessing: boolean;

  /** Open panel for an entity — if a session exists, pass its ID */
  openPanel: (target: ConversationTarget, sessionId?: string) => void;
  /** Close the panel */
  closePanel: () => void;
  /** Set the active session (after starting QA or finding existing session), or null to reset */
  setSessionId: (id: string | null) => void;
  /** Mark processing state */
  setProcessing: (v: boolean) => void;
}

export const useConversationStore = create<ConversationState>()((set) => ({
  isOpen: false,
  sessionId: null,
  target: null,
  isProcessing: false,

  openPanel: (target, sessionId) =>
    set({ isOpen: true, target, sessionId: sessionId ?? null, isProcessing: false }),

  closePanel: () =>
    set({ isOpen: false, sessionId: null, target: null, isProcessing: false }),

  setSessionId: (id) => set({ sessionId: id ?? null }),

  setProcessing: (v) => set({ isProcessing: v }),
}));
